import { render, staticRenderFns } from "./ForYouSwipeCards.vue?vue&type=template&id=ff7c1e2c&scoped=true"
import script from "./ForYouSwipeCards.vue?vue&type=script&lang=js"
export * from "./ForYouSwipeCards.vue?vue&type=script&lang=js"
import style0 from "./ForYouSwipeCards.vue?vue&type=style&index=0&id=ff7c1e2c&prod&lang=scss&scoped=true"
import style1 from "./ForYouSwipeCards.vue?vue&type=style&index=1&id=ff7c1e2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7c1e2c",
  null
  
)

export default component.exports